import { useEffect, useState } from 'react';

export default function HeroSection() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/613ea9252a7cdeb8260a69797970f272.jpg"
          alt="Hero background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-black/70 via-black/55 to-black/65"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-12 flex flex-col lg:flex-row items-center gap-16">
        {/* Left Text */}
        <div className="flex-1 text-center lg:text-left">
          <div
            className={`transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
          >
            <p className="text-amber-400 text-xs font-semibold uppercase tracking-[0.3em] mb-5">
              iOS App Development
            </p>
            <h1 className="text-5xl md:text-6xl xl:text-7xl font-extrabold text-white leading-[1.08] mb-6">
              Crafting Premium<br />
              <span className="text-amber-400">iOS</span> Experiences
            </h1>
            <p className="text-white/70 text-lg md:text-xl max-w-xl mx-auto lg:mx-0 leading-relaxed">
              DUGAN d.o.o. is a team of experts building modern applications for the iOS
              platform — enhancing user experience and improving mobile security.
            </p>
          </div>

          <div
            className={`mt-10 flex items-center gap-6 justify-center lg:justify-start transition-all duration-700 delay-200 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
          >
            <div className="flex items-center gap-2 text-white/60 text-sm">
              <span className="w-8 h-[1px] bg-amber-400 inline-block"></span>
              <span>VPN Security</span>
            </div>
            <div className="w-1 h-1 rounded-full bg-white/30"></div>
            <div className="flex items-center gap-2 text-white/60 text-sm">
              <span className="w-8 h-[1px] bg-amber-400 inline-block"></span>
              <span>Phone Cleaner</span>
            </div>
          </div>
        </div>

        {/* Right Visual */}
        <div
          className={`flex-shrink-0 w-full lg:w-[420px] transition-all duration-1000 delay-300 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}
        >
          <div className="relative mx-auto w-[280px] md:w-[340px]">
            <div className="absolute -inset-6 rounded-3xl bg-amber-400/10 blur-2xl"></div>
            <img
              src="https://readdy.ai/api/search-image?query=modern%20iPhone%20smartphone%20with%20sleek%20iOS%20app%20interface%20on%20screen%2C%20dark%20premium%20design%2C%20glowing%20amber%20and%20white%20UI%20elements%2C%20floating%20device%20mockup%20on%20transparent%20background%2C%20professional%20product%20photography%20style%2C%20studio%20lighting%2C%20high%20resolution%20clean%20product%20shot%2C%20minimal%20background&width=400&height=600&seq=hero002&orientation=portrait"
              alt="iOS App Preview"
              className="relative z-10 w-full h-auto rounded-3xl object-cover object-top shadow-2xl"
            />
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 text-white/40">
        <span className="text-xs uppercase tracking-widest">Scroll</span>
        <i className="ri-arrow-down-line animate-bounce text-lg"></i>
      </div>
    </section>
  );
}
